import { ENewAnswerModalStep, INewAnswer } from '../../types/newAnswer';
import { TReduxActions } from '../../types/redux';
import {
  EOpenNewAnswerForm,
  EAnswerTextTypes,
  EStepActionTypes,
  EUserStatusActionTypes,
  ENameActionTypes,
  ENewAnswerForm,
  EAnonymousActionTypes,
  EErrorTypes,
} from '../../actions/newAnswer';

export const defaultNewAnswer: INewAnswer = {
  meta: {
    openId: null,
    step: ENewAnswerModalStep.Answer,
  },
  data: {
    isAnonymous: null,
    name: null,
    userStatus: null,
    answer: '',
    error: '',
  },
};

export const newAnswerReducer = (state = defaultNewAnswer, action: TReduxActions) => {
  switch (action.type) {
    case EOpenNewAnswerForm.Open: {
      return { ...state, meta: { ...state.meta, openId: action.payload } };
    }
    case EOpenNewAnswerForm.Close: {
      return { ...state, data: { ...state.data, answer: '', error: '' }, meta: { ...state.meta, openId: null } };
    }
    case EStepActionTypes.Set: {
      return { ...state, meta: { ...state.meta, step: action.payload } };
    }
    case ENameActionTypes.SetName: {
      return { ...state, data: { ...state.data, name: action.payload } };
    }
    case EUserStatusActionTypes.SetUserStatus: {
      return { ...state, data: { ...state.data, userStatus: action.payload } };
    }
    case EAnswerTextTypes.Set: {
      return { ...state, data: { ...state.data, answer: action.payload } };
    }
    case EAnonymousActionTypes.Set: {
      return { ...state, data: { ...state.data, isAnonymous: action.payload } };
    }
    case EErrorTypes.Set: {
      return { ...state, data: { ...state.data, error: action.payload } };
    }
    case ENewAnswerForm.Clear: {
      return defaultNewAnswer;
    }
    default: {
      return state;
    }
  }
};
